import { Collapsible } from '@/components/ui/collapsible';
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { NavLink } from 'react-router';

export function NavMain({ items, isSidebarOpen }) {
  return (
    <SidebarGroup className="pt-1">
      <SidebarMenu>
        {items.map((item) => (
          <Collapsible
            key={item.title}
            asChild
            defaultOpen={item.isActive}
            className="group/collapsible"
          >
            <SidebarMenuItem>
              <NavLink to={item.url}>
                {({ isActive }) => (
                  <SidebarMenuButton
                    tooltip={item.title}
                    id={item.title}
                    isActive={isActive}
                    className={`${isActive ? 'border-l-4 border-primary data-[active=true]:text-primary' : ''} ${
                      isSidebarOpen ? '' : 'md:justify-center'
                    }`}
                  >
                    <item.icon style={{ height: 20, width: 20 }} />
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                )}
              </NavLink>
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
